import React from 'react';
import { CardTitle, Typography, Button } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { Subscription } from '@one-thd/sui-icons';

const SubscriptionsText = ({ className, hideTitle, fullWidthButton }) => {
  const bulletPoints = [
    'Save 5% on every eligible subscription item',
    'Set it and forget it with automatic deliveries',
    'Modify or cancel subscriptions anytime'
  ];

  const classes = classNames('sui-flex sui-flex-col sui-gap-6', className);

  return (
    <div className={classes}>
      {!hideTitle && 
        <div className="sui-flex sui-items-center sui-gap-3">
          <Subscription />
          <CardTitle headerWeight="bold" header="Subscriptions" />
        </div>
      }
      <div>
        <Typography variant="h2" weight="display">Never Run Out of Your Favorites.</Typography>
        <Typography variant="h2" weight="display">Save 5% on subscription items.</Typography>
      </div>
      <ul className="sui-list-disc">
        {bulletPoints.map((str, index) => {
          return (<li className="sui-ml-8 sui-text-base" key={index}>{str}</li>);
        })}
      </ul>
      <div className="sui-mt-auto">
        <Button
          variant="secondary"
          onClick={() => {
            window.location.href = '/c/subscription_service';
          }}
          fullWidth={fullWidthButton}
        >Explore Subscriptions
        </Button>
      </div>
    </div>
  );
};

export { SubscriptionsText };